import "@/App.css";
import { Toaster } from "sonner";
import HeightMapGenerator from "@/pages/HeightMapGenerator";

function App() {
  return (
    <div className="App min-h-screen bg-[#0b0c10] text-zinc-100">
      <HeightMapGenerator />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141519",
            border: "1px solid #232428",
            color: "#f4f4f5",
          },
        }}
      />
    </div>
  );
}

export default App;
